<style lang="scss" scoped>
.stories {
  margin-top: 20px;
  
  @media screen and (max-width: 768px) {
    margin-top: 0px;
  }
}
.story-header {
  color: #000 !important;
  text-align: left;
  cursor: pointer;

  &.gold {
    color: #957513 !important;
  }

  &:hover {
    // text-decoration: none;
  }

  &.expand {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    text-decoration: none;
    user-select: none;

    @media screen and (max-width: 768px) {
      margin-bottom: 0px;
    }

    i {
      margin-left: -5px;
    }
  }
}
.expanded-story {
  border-bottom: solid 1px #999;
  text-align: left;
  margin: 0 0 20px;
  padding: 10px 0;
  width: 100%;
  @media screen and (max-width: 768px) {
    line-height: 18px;
    padding: 0;
  }
}
.active-story {
  text-align: left;
  @media screen and (max-width: 768px) {
    line-height: 18px;
  }
}
.active-story-header {
  margin-top: -10px;
  @media screen and (max-width: 768px) {
    margin-top: 3px;
  }
}
</style>
<template>
  <div class="stories">
    <strong
      v-if="activeYear"
      class="story-header expand"
      :class="{gold: activeStory}"
      @click="$emit('setActiveStory', null)"
    >
      <!-- @click="expanded = !expanded" -->
      <!-- <i
          v-if="expanded"
          class="icon ion-md-remove-circle"
        />
        <i
          v-else
          class="icon ion-md-add-circle"
        /> -->
      <!-- {{ expanded ? 'Collapse' : 'Expand' }}  -->
      stories written in {{ activeYear }}
    </strong>
    <div
      class="frow centered active-story"
      :class="{'active-story-header' : activeStory}"
    >
      <div
        v-if="activeStory"
        class="expanded-story"
      >
        <strong>{{ activeStory.title }}</strong>
        <div v-html="parseStoryBody(activeStory)" />
        <br>
        <span v-if="!activeStory.isIntroStory"> [{{ $moment(activeStory.date).format("MM/DD/YYYY") }}]</span>
      </div>
      <div v-else-if="!activeYear">
        <br>
        <div v-if="activeArt">
          Would you like to see a story about this artwork? email <a href="mailto:roz@artstory.net">roz@artstory.net</a>
        </div>
        <div v-else>
          CLICK-A-YEAR to dive deeper into ARTSTORY
        </div>
      </div>
    </div> 
    <!-- <StoryReferences
      :active-art="activeArt"
      :active-story="activeStory"
      :stories="unfilteredStories"
      :make-links="true"
      @setActiveStoryReference="$emit('setActiveStory', $event)"
    /> -->
    <div 
      v-if="activeYear && !activeStory"
      class="frow column-start"
    >
      <div
        v-for="story in stories"
        :key="`s-${story.id}`"
        class="frow justify-start width-100"
      >
        <a
          class="story-header"
          @click="$emit('setActiveStory', story)"
        >
          <!-- @click="$set(story, 'expanded', !story.expanded)" -->
          <strong>
            {{ story.title }} 
          </strong>
          <!-- [{{ $moment(story.date).format("MM/DD/YYYY") }}] -->
        </a>
        <!-- <div
          v-if="story.expanded"
          class="expanded-story"
          v-html="parseStoryBody(story)"
        /> -->
      </div>
    </div>
  </div>
</template>
<script>
import StoryReferences from '@/components/StoryReferences.vue';
import { parseUrlStrings } from '@/utils/parsing';

export default {
  name: 'Stories',
  components: {
    StoryReferences,
  },
  props: {
    activeArt: {
      type: Object,
      default: () => {},
    },
    activeStory: {
      type: Object,
      default: () => null,
    },
    activeYear: {
      type: String,
      default: null,
    },
    stories: {
      type: Array,
      default: () => [],
    },
    unfilteredStories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    parseStoryBody(story) {
      return parseUrlStrings(story.description);
    },
  },
};
</script>
